import React, { useEffect } from 'react'
import Header from './Header'
import Cart from './Cart'
import Footer from './Footer'
import { connect } from 'react-redux'
import { totalCartCountSelector } from '../redux/reducers/cart'
import { loadCart } from '../redux/actions/cart'
import { useHistory, Link, Redirect } from 'react-router-dom'

function Checkout({ itemCount, items, loadCart, cartDetails, orderRedirect }) {
    const history = useHistory();

    useEffect(() => {
        loadCart();
    }, [])

    if (orderRedirect) {
        return <Redirect to="/finalcart" />
    }

    return (
        <>
            <Header itemCount={itemCount} />
            <div className="view-cart" style={{ marginTop: "51px" }}>
                <div className="container">
                    <div className="main-cart">
                        <div className="cart-item-details">
                            <div className="container">
                                <div className="cart-header">
                                    <span className="item-count font-bold">{itemCount} Items in cart</span>
                                    <Link className="text-pink text-right" to="/"><span className="fa fa-plus pr-10"></span>ADD MORE ITEMS</Link>
                                </div>
                                {cartDetails?.cart && <Cart items={cartDetails?.cart.cart_content} cartDetails={cartDetails} />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {cartDetails?.cart && <Footer cartDetails={cartDetails} />}
        </>
    )
}

const mapStateToProps = (state) => ({
    itemCount: totalCartCountSelector(state),
    items: state.cart.items,
    cartDetails: state.cart.serverCart,
    orderRedirect: state.cart.orderRedirect,
})

export default connect(mapStateToProps, { loadCart })(Checkout)

